import { Icon } from '../../design-system/icons';
import { SETUP_SLIDE_EASE, SETUP_SLIDE_MS } from './setupStepPhase';

/**
 * Encabezado de progreso del cuestionario de onboarding: botón volver
 * (`outline/move-left`) + barra de progreso + indicador "N de TOTAL".
 * Compartido por los pasos del "Account setup".
 */
export interface SetupProgressProps {
  step: number;
  total: number;
  /**
   * Vuelve al paso anterior. En el paso 1 no hay paso anterior: ahí volver **sale del
   * onboarding cerrando la sesión** (ADR-2026-08-03-volver-en-el-paso-1-desloguea), y
   * el layout es quien decide eso — acá la flecha se dibuja siempre igual.
   */
  onBack: () => void;
}

export function SetupProgress({ step, total, onBack }: SetupProgressProps) {
  return (
    <div className="flex items-center gap-8">
      <button
        type="button"
        onClick={onBack}
        aria-label="Volver"
        className="-m-1 shrink-0 rounded-full p-1 text-[#18181B] transition-colors hover:bg-[#F4F4F5]"
      >
        <Icon name="outline/move-left" size={24} />
      </button>
      <div
        className="h-1.5 flex-1 overflow-hidden rounded-full bg-[#F4F4F5] md:h-2"
        role="progressbar"
        aria-valuenow={step}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={`Paso ${step} de ${total}`}
      >
        <div
          className="h-full rounded-full bg-[#18181B]"
          style={{
            width: `${(step / total) * 100}%`,
            // Misma duración/curva que el slide para que barra y pantalla viajen juntas.
            transition: `width ${SETUP_SLIDE_MS}ms ${SETUP_SLIDE_EASE}`,
          }}
        />
      </div>
      <span className="shrink-0 text-[14px] font-[600] leading-[19px] text-[#18181B]">
        {step} de {total}
      </span>
    </div>
  );
}

export default SetupProgress;
